import React, { useState } from 'react';
import axios from 'axios'; 
import './EncoderComponent.css';
import { Upload } from 'lucide-react';

function DecoderComponent() {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);

  const handleImageChange = (e) => setImage(e.target.files[0]);

  const handleDecode = async () => {
    if (!image) {
      alert('Please upload an image to decode');
      return;
    }

    const formData = new FormData();
    formData.append('image', image);

    setLoading(true);
    setDownloadUrl(null);

    const baseUrl = process.env.REACT_APP_BE_URL || 'https://datamask-api.onrender.com';

    try {
      const response = await axios.post(`${baseUrl}/decode`, formData, {
        responseType: 'blob', 
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      setDownloadUrl(URL.createObjectURL(blob));
    } catch (error) {
      alert('Error decoding image');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="encoder-main">
      <div className="encoder-card">
        <h2 className="encoder-title">Decode an Image</h2>
        <div className="upload-container">
          <div className="upload-section">
            <label className="upload-label">Upload Image to decode:</label>
            <div className="upload-area">
              <label className="upload-box">
                <Upload className="upload-icon" />
                <span className="upload-text">
                  {image ? image.name : 'Choose an image or drag it here'}
                </span>
                <input 
                  id="imageToDecode" 
                  type="file" 
                  className="hidden" 
                  accept="image/*"  // Accept only image files
                  onChange={handleImageChange} 
                />
              </label>
            </div>
          </div>
          
          <button className="upload-button" onClick={handleDecode}>
            Upload
          </button>
        </div>
        
        {loading && <div className="progress">Decoding in progress...</div>}
        {downloadUrl && (
          <div className="result">
            <a href={downloadUrl} download="decoded_file">Download Decoded File</a>
          </div>
        )}
      </div>
    </main>
  );
}

export default DecoderComponent;
